import type { SVGProps } from 'react'
const SvgSyNotebook = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M3.5 7a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0 8a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0-4a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z" />
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M5.01 5.695c-.003.143-.005.214.039.26s.116.045.26.045H7.5a1.5 1.5 0 1 1 0 3H5.3c-.141 0-.212 0-.256.044S5 9.159 5 9.3v.4c0 .141 0 .212.044.256S5.159 10 5.3 10h2.2a1.5 1.5 0 0 1 0 3H5.3c-.141 0-.212 0-.256.044S5 13.159 5 13.3v.4c0 .141 0 .212.044.256S5.159 14 5.3 14h2.2a1.5 1.5 0 0 1 0 3H5.3c-.141 0-.212 0-.256.044S5 17.159 5 17.301c.002 1.687.032 2.56.586 3.113C6.172 21 7.114 21 9 21h6c1.886 0 2.828 0 3.414-.586S19 18.886 19 17V7c0-1.886 0-2.828-.586-3.414S16.886 3 15 3H9c-1.886 0-2.828 0-3.414.586-.432.431-.545 1.056-.575 2.11"
			clipRule="evenodd"
		/>
		<path d="M15.5 7a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5" />
	</svg>
)
export default SvgSyNotebook
